function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Ajax } from "zengular-util";
import Endpoints from "../constants/end-points";

var Comment = /*#__PURE__*/function () {
  function Comment() {
    _classCallCheck(this, Comment);
  }

  _createClass(Comment, null, [{
    key: "getStream",
    value: function getStream(streamId, page) {
      return Ajax.get(Endpoints.comment.all(streamId, page)).getJson;
    }
  }, {
    key: "send",
    value: function send(streamId, replyId, sendAs, text) {
      return Ajax.json(Endpoints.comment.post(streamId, replyId, sendAs), {
        text: text
      }).getJson;
    }
  }, {
    key: "moderate",
    value: function moderate(streamId, commentId, mode) {
      return Ajax.json(Endpoints.comment.moderate(streamId, commentId, mode)).getJson;
    }
  }, {
    key: "get",
    value: function get(streamId, id) {
      return Ajax.get(Endpoints.comment.get(streamId, id)).getJson;
    }
  }, {
    key: "selfModerate",
    value: function selfModerate(streamId, id) {
      return Ajax.json(Endpoints.comment["self-moderate"](streamId, id)).getJson;
    }
  }]);

  return Comment;
}();

export { Comment as default };